import {
    CREATE_USER,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAIL
} from './actionTypes';

const initialState = {
    userToCreate: {},
    createdUser: {},
    loading: false,
    loaded: false,
    error: null
};

export function createUserReducer(state = initialState, action) {
    switch (action.type) {
        case CREATE_USER: {
            return {
                ...state,
                userToCreate: action.payload,
                loading: true
            };
        }
        case CREATE_USER_SUCCESS: {
            return {
                ...state,
                createdUser: action.payload,
                loading: false,
                loaded: true
            };
        }
        case CREATE_USER_FAIL: {
            return {
                ...initialState,
                userToCreate: state.userToCreate,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
